import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  actions: {
    paddingTop: '14px',
    '& label': {
      marginLeft: '8px',
    },
  },
});
